<small class="debug">{{me}}</small>

<!-- Modern Control Bar -->
<div class="layers-control-bar">
  <mat-form-field class="filter-search" appearance="outline">
    <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input inputrestriction="basic1" matInput type="text" name="SearchDualList"
           (keyup)="changeSearchKey()" [(ngModel)]="filter" autocomplete="off"/>
    <button matSuffix mat-icon-button aria-label="clear" (click)="clearSearchKey()" *ngIf="filter">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <div class="control-buttons">
    <button mat-icon-button class="control-btn"
            [class.inactive]="activeIds[0] == selectedSceneId"
            (click)="toggleLockedItem($event, true)"
            matTooltip="{{'general.lockItem' | transloco}}">
      <mat-icon>lock</mat-icon>
    </button>
    <button mat-icon-button class="control-btn"
            [class.inactive]="activeIds[0] == selectedSceneId"
            (click)="toggleInvisibleItem($event, true)"
            matTooltip="{{'general.hideItem' | transloco}}">
      <mat-icon>visibility_off</mat-icon>
    </button>
  </div>

  <div class="hide-gt-sm">
    <app-scroll-buttons contentId="items"></app-scroll-buttons>
  </div>
  <app-video-link videoLink="layers"></app-video-link>
</div>

<div class="scene-tree" id="items">
  <!-- Root Scene Node -->
  @if (rootNode) {
    <div id="layer_{{selectedSceneId}}" class="root-node layer-item"
         (click)="onItemClick(rootNode, $event)"
         [class.layer-active]="activeIds.indexOf(selectedSceneId) > -1">
      <div class="layer-content">
        <div class="layer-icon">
          <fa-icon [icon]="rootNode.icon"></fa-icon>
        </div>
        <span class="layer-name">{{rootNode.filename}}</span>
        <div class="layer-actions">
          <button mat-icon-button class="action-btn expand-btn" (click)="expandTree1 = !expandTree1; $event.stopPropagation()">
            <mat-icon>{{ expandTree1 ? 'expand_more' : 'chevron_right' }}</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Layer List -->
  @if (expandTree1) {
    <div class="layers-container">
      <!-- Fixed Background Layers -->
      @for (node of filteredSource['fixed']; track node) {
        <div class="layer-item layer-fixed disable-selection" id="layer_{{node.id}}">
          <div class="layer-content">
            <div class="layer-icon background-icon">
              <fa-icon [icon]="node.icon"></fa-icon>
            </div>
            <span class="layer-name">{{node.filename}}</span>
            <div class="layer-actions">
              <button mat-icon-button class="action-btn background-badge"
                      (click)="toggleLockedItem($event, false, node)"
                      matTooltip="{{'general.background' | transloco}}">
                <mat-icon>image</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }

      <!-- Draggable Common Layers -->
      <div cdkDropList class="node-list" (cdkDropListDropped)="dropItem($event)" [cdkDropListData]="filteredSource['common']">
        @for (node of filteredSource['common']; track node) {
          @defer() {
            <div class="layer-item"
                 id="layer_{{node.id}}"
                 cdkDrag
                 [cdkDragData]="node"
                 [cdkDragDisabled]="node.invisible || node.locked"
                 (click)="onItemClick(node, $event)"
                 [class.layer-active]="activeIds.indexOf(node.id) > -1"
                 [class.layer-disabled]="node.invisible || node.locked">

              <div class="layer-content">
                <div class="drag-handle" [class.drag-handle-disabled]="node.invisible || node.locked">
                  <mat-icon>drag_indicator</mat-icon>
                </div>
                <div class="layer-icon" [class.icon-disabled]="node.invisible || node.locked">
                  <fa-icon [icon]="node.mimeType ? (node.mimeType | PipeIcon) : node.icon"></fa-icon>
                </div>
                <span class="layer-name">{{node.filename}}</span>
                <div class="layer-actions">
                  @if (node.locked) {
                    <button mat-icon-button class="action-btn locked-btn"
                            (click)="toggleLockedItem($event, false, node)"
                            matTooltip="{{'general.unlock' | transloco}}">
                      <mat-icon>lock</mat-icon>
                    </button>
                  }
                  @if (node.invisible) {
                    <button mat-icon-button class="action-btn invisible-btn"
                            (click)="toggleInvisibleItem($event, false, node)"
                            matTooltip="{{'general.show' | transloco}}">
                      <mat-icon>visibility_off</mat-icon>
                    </button>
                  }
                </div>
              </div>

              <div class="drag-placeholder" *cdkDragPlaceholder></div>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
